{
  "name": "@gabrielhicks/solv",
  "version": "5.8.35",
  "description": "Solana Validator CLI SOLV",
  "main": "dist/index.js",
  "type": "module",
  "repository": "https://github.com/gabrielhicks/solv",
  "keywords": [
    "solana",
    "validator",
    "cli",
    "validator-tool",
    "Node.js",
    "web3"
  ],
  "files": [
    "dist",
    "dist/cli/monitoring/scripts",
    "dist/cli/chrony"
  ],
  "author": "ELSOUL LABO B.V.",
  "private": false,
  "license": "Apache-2.0",
  "bin": {
    "solv": "./dist/index.js"
  },
  "solv": {
    "targetNode": "24.16.0",
    "targetPnpm": "latest"
  },
  "scripts": {
    "test": "vitest",
    "build": "tsup src/index.ts && npx tsx add-line.ts",
    "dev": "nodemon",
    "start": "node dist/index.js"
  },
  "dependencies": {
    "@jup-ag/api": "6.0.27",
    "@metaplex-foundation/mpl-token-metadata": "3.2.1",
    "@metaplex-foundation/umi": "0.9.2",
    "@metaplex-foundation/umi-bundle-defaults": "0.9.2",
    "@skeet-framework/utils": "1.3.11",
    "@solana/spl-stake-pool": "1.1.5",
    "@solana/spl-token": "0.4.8",
    "@solana/web3.js": "1.98.4",
    "bigint-buffer": "1.1.5",
    "bn.js": "5.2.1",
    "bs58": "6.0.0",
    "chalk": "5.3.0",
    "chalk-pipe": "6.1.0",
    "cli-progress": "3.12.0",
    "cli-spinner": "0.2.10",
    "cli-table3": "0.6.5",
    "commander": "12.1.0",
    "dotenv": "16.4.5",
    "inquirer": "10.2.0",
    "node-fetch": "3.3.2",
    "prompt": "1.3.0"
  },
  "devDependencies": {
    "@changesets/changelog-github": "0.5.0",
    "@changesets/cli": "2.27.7",
    "@solana-developers/helpers": "^2.5.6",
    "@swc/core": "1.7.21",
    "@types/bn.js": "5.1.5",
    "@types/cli-progress": "3.11.6",
    "@types/cli-spinner": "0.2.3",
    "@types/inquirer": "9.0.7",
    "@types/node": "22.5.1",
    "@types/node-fetch": "2.6.11",
    "@types/prompt": "1.1.8",
    "@typescript-eslint/eslint-plugin": "8.3.0",
    "@typescript-eslint/parser": "8.3.0",
    "eslint": "9.9.1",
    "eslint-config-prettier": "9.1.0",
    "nodemon": "3.1.7",
    "prettier": "3.3.3",
    "tsup": "8.2.4",
    "typescript": "5.5.4",
    "vite": "5.4.2",
    "vite-tsconfig-paths": "5.0.1",
    "vitest": "2.0.5"
  },
  "overrides": {
    "chalk": "5.3.0",
    "strip-ansi": "7.1.0",
    "color-convert": "2.0.1",
    "color-name": "1.1.4",
    "is-core-module": "2.13.1",
    "error-ex": "1.3.2",
    "has-ansi": "5.0.1",
    "uuid": "9.0.1"
  },
  "pnpm": {
    "onlyBuiltDependencies": [
      "bigint-buffer",
      "bufferutil",
      "utf-8-validate"
    ]
  }
}
